<template>
  <v-row no-gutters class="fill-height">
    <!-- Intro view -->
    <v-col cols="12" v-if="fetchingView" class="mobile-fetching-view fill-height">
      <the-sidebar-header style="height: 70px !important" class="flex-grow-0 px-4" mobile />
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <img :src="require(`@/assets/images/map.png`)" class="pa-5 pt-11" width="85%" />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="text-center text-body-2 px-4">
          <p class="primary--text font-weight-medium font-size-16" style="line-height: 24px">
            {{ $i18n.t('default.lodzInvestOffersDataBase') }}
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-6">
        <v-col cols="12" class="text-center px-8">
          <base-button
            text="buttons.startSearching"
            color="secondary"
            style="width: 100%; height: 42px"
            @click="fetchingView = false"
          />
        </v-col>
      </v-row>
    </v-col>
    <!-- Tabs view -->
    <v-col cols="12" v-else class="fill-height">
      <template v-if="isFetched">
        <the-sidebar-header class="flex-grow-0 py-1 px-4" style="height: 70px !important" mobile />
        <v-row no-gutters justify="center" align="center" class="mobile-tabs" style="height: 50px !important">
          <v-col
            v-for="(tab, idx) of tabs"
            :key="idx"
            :cols="12 / tabs.length"
            @click="currentTab = idx"
            class="py-3 cursor-pointer text-body-2 text-center mobile-tab"
            :class="{ 'mobile-tab-active': currentTab === idx }"
          >
            <span class="pr-1">
              <v-icon class="mobile-tab-icon" :class="{ 'mobile-tab-icon-active': currentTab === idx }">
                {{ tab.icon }}
              </v-icon>
            </span>
            <span>
              {{ tab.text }}
            </span>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align="center" style="height: calc(100vh - 120px) !important">
          <v-tabs :height="36" hide-slider grow class="fill-height">
            <v-tabs-items v-model="currentTab" touchless style="background-color: transparent" class="fill-height">
              <v-tab-item v-for="(tab, idx) of tabs" :key="idx" class="fill-height">
                <v-col cols="12" class="pa-0 fill-height">
                  <component :is="`TheMobile${$_capitalize(tab.name)}`" class="fill-height" />
                </v-col>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-row>
        <!-- Identification -->
        <the-mobile-identification v-if="isIdentificationVisible" />
        <!-- Filters -->
        <the-mobile-filters v-show="isFilterVisible" />
        <!-- Legend -->
        <the-mobile-legend v-show="isLegendVisible" />
      </template>
      <main-loader v-else />
    </v-col>
  </v-row>
</template>
<script>
import { call, get, sync } from 'vuex-pathify';
import BaseButton from '@/components/shared/buttons/BaseButton';
import BaseRoundedButton from '@/components/shared/buttons/BaseRoundedButton';
import MainLoader from '@/components/shared/MainLoader.vue';
import TheMobileList from '@/components/mobile/TheMobileList';
import TheMobileMap from '@/components/mobile/TheMobileMap';
import TheSidebarHeader from '@/components/sidebar/TheSidebarHeader';

import TheMobileFilters from '@/components/mobile/TheMobileFilters';
import TheMobileIdentification from '@/components/mobile/TheMobileIdentification';
import TheMobileLegend from '@/components/mobile/TheMobileLegend';

import mobileFilters from '@/mixins/map/mobileFilters';
export default {
  name: 'MainMobileView',
  mixins: [mobileFilters],
  components: {
    BaseButton,
    BaseRoundedButton,
    MainLoader,
    TheMobileList,
    TheMobileMap,
    TheSidebarHeader,

    TheMobileFilters,
    TheMobileIdentification,
    TheMobileLegend,
  },
  computed: {
    settingsValues: get('admin/settings'),
    isFilterVisible: sync('tools/isFilterVisible'),
    isLegendVisible: sync('tools/isLegendVisible'),
    currentTab: sync('tools/currentTab'),
    currentLng() {
      return this.$i18n.locale;
    },
    tabs() {
      return [
        {
          name: 'list',
          text: this.$i18n.t('mobile.tabs.list'),
          icon: 'mdi-format-list-bulleted',
        },
        {
          name: 'map',
          text: this.$i18n.t('mobile.tabs.map'),
          icon: 'mdi-map-marker',
        },
      ];
    },

    fid() {
      return +this.$route.params?.fid;
    },
    lid() {
      return +this.$route.params?.lid;
    },
    isIdentificationVisible() {
      return (this.lid || this.lid === 0) && (this.fid || this.fid === 0);
    },
  },
  data: () => ({
    isFetched: false,
    fetchingView: true,
  }),
  methods: {
    getDataSources: call('featuresData/getDataSources'),
    getLayers: call('featuresData/getLayers'),
    getProjects: call('featuresData/getProjects'),
    getMobileLayersFeatures: call('featuresData/getMobileLayersFeatures'),
    async fetchInitData() {
      this.isFetched = false;
      const languagesProjectsIds = this.$_config.languages.reduce((total, current) => {
        total[current] = this.settingsValues['PROJECTS_LEGEND_SETTING']?.value[current];
        return total;
      }, {});
      const offersLayersIds = this.$_config.languages.reduce((total, lng) => {
        const lngLayers = ['BROWNFIELDS_LAYERS_SETTING', 'GREENFIELDS_LAYERS_SETTING', 'INVESTED_LAYERS_SETTING']
          .map(setting => {
            return this.settingsValues[setting]?.value?.layers?.[lng];
          })
          .filter(layerId => !!layerId);
        total[lng] = lngLayers;
        return total;
      }, {});
      await Promise.all([
        this.getProjects(languagesProjectsIds),
        this.getLayers(),
        this.getDataSources(),
        this.getMobileLayersFeatures({ layers: offersLayersIds, lng: this.currentLng }),
      ]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.fetchInitData();
  },
};
</script>
<style lang="scss" scoped>
.mobile-tabs {
  height: 46px !important;
}
.mobile-tab {
  @include border(top, 1px, rgba(0, 0, 0, 0.12));
  @include border(bottom, 1px, rgba(0, 0, 0, 0.12));
  background-color: #fafafa;
  font-weight: 500;
}
.mobile-tab-active {
  color: map-get($colors, 'secondary');
}
::v-deep {
  .v-tabs-bar {
    display: none;
  }
}
.mobile-fetching-view {
  background-image: url('~@/assets/images/sidebar-pattern.png');
  background-repeat: repeat;
  background-size: 500%;
  background-blend-mode: lighten;
  background-color: rgba(255, 255, 255, 0.97);
}
.mobile-tab-icon {
  color: map-get($colors, 'font');
}
.mobile-tab-icon-active {
  color: map-get($colors, 'secondary');
}
.border-top {
  @include border(top, 1px, rgba(0, 0, 0, 0.12));
}
::v-deep {
  .mobile-panel {
    position: absolute;
    top: 70px;
    background-color: #fafafa;
    z-index: 2;
  }
  .mobile-panel-header {
    @include border(top, 1px, rgba(0, 0, 0, 0.12));
    @include border(bottom, 1px, rgba(0, 0, 0, 0.12));
  }
  .input-append {
    padding-top: 7px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }
}
</style>
